import Vue from 'vue';
import numeral from 'numeral';
import date from 'date-fns';

export const formatWideDecimal = value => {
  const number = Number(value);
  if (isNaN(number)) return value;
  const absValue = Math.abs(number);
  if (absValue < 1) return numeral(number).format('0.00');
  if (absValue >= 1 && absValue <= 99999) return numeral(number).format('0.00');
  if (absValue > 99999)
    return numeral(number)
      .format('0.0a')
      .toUpperCase();
};
export const formatWideInt = value => {
  const number = Number(value);
  if (isNaN(number)) return;
  return numeral(number)
    .format('10,000')
    .toUpperCase();
};

export const formatFileSize = size => {
  if (size > 1024 * 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB';
  } else if (size > 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB';
  } else if (size > 1024 * 1024) {
    return (size / 1024 / 1024).toFixed(2) + ' MB';
  } else if (size > 1024) {
    return (size / 1024).toFixed(2) + ' KB';
  }
  return size.toString() + ' B';
};

export const camelCase = text => {
  if (!text) return text;
  return text.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
    if (+match === 0) return ''; // or if (/\s+/.test(match)) for white spaces
    return index == 0 ? match.toLowerCase() : match.toUpperCase();
  });
};

export default function registerFilters() {
  Vue.filter('formatMoneyObjToString', val => {
    return val ? val.amount : '-';
  });
  Vue.filter('capitalize', value => {
    if (!value) return '';
    return (
      value
        .toString()
        .charAt(0)
        .toUpperCase() + value.slice(1)
    );
  });

  Vue.filter('formatWideDecimal', formatWideDecimal);
  Vue.filter('camelCase', camelCase);
  Vue.filter('formatFileSize', formatFileSize);
  Vue.filter('formatWideInt', formatWideInt);
  Vue.filter('upperCase', val => {
    if (typeof val === 'string' || val instanceof String) {
      return val.toUpperCase();
    }

    return val;
  });
  Vue.filter('lowerCase', val => {
    if (typeof val === 'string' || val instanceof String) {
      return val.toLowerCase();
    }

    return val;
  });

  Vue.filter('formatDate', value =>
    value ? date.format(value, 'DD.MM.YYYY') : ''
  );
  Vue.prototype.$filters = Vue.options.filters;
}
